/**
 * **Why this is needed:**
 * The frontend has no other way to determine if an action is read-only besides checking
 * the action name. That's why we need to add  GET endpoint permissions here that use
 * non-standard action names but should be treated as read-only operations. This allows
 * users with `admin:query` permission to access these endpoints without requiring explicit grants
 */
export const CUSTOM_READ_PERMISSIONS = [
    'airwallex/customers:retrieve',
    'airwallex/intents:retrieve',
    'airwallex/intents:retrieverefund',
    'airwallex:authcode',
    'airwallex:getbalances',
    'airwallex:getdeposit',
    'airwallex:getenvironment',
    'airwallex:getpayout',
    'allianz/companies:getcompany',
    'allianz/credentials:status',
    'assistant/thread:getlatest',
    'atradius/companies:find',
    'attachments:getdownloadurl',
    'audits:querydirect',
    'audits:queryindirect',
    'audits:queryusers',
    'auth/applications:getbyclientid',
    'auth:googleauth',
    'auth:googlecallbackget',
    'auth:healthstatus',
    'auth:microsoftauth',
    'auth:microsoftcallbackget',
    'auth:verifyemail',
    'bank-account:queryreceivingbankaccounts',
    'bank-transactions:getbanktransactionsstatus',
    'billings:counters',
    'billings:getautochargestatus',
    'billings:indicators',
    'businesses/contacts:findbycontactid',
    'buyers/insurance:counters',
    'buyers/ownership:buyerusers',
    'buyers:counters',
    'buyers:match',
    'charges:chargedates',
    'charges:count',
    'charges:getstatusdates',
    'checkout:getstatusdates',
    'configs/stripe:getstripepublickey',
    'connected-accounts/accounts:accountsbalances',
    'credit-requirements:getme',
    'credit-reviews:config',
    'credit-safe/reports:getorcreatereport',
    'creditline:buyercredit',
    'currency-exchanges:search',
    'currency-exchanges:searchbuyer',
    'currency-exchanges:searchsupplier',
    'emails:html',
    'erp-sync/config:getautopaymentrequestsenabled',
    'erp-sync/config:getinvoicecutoffdate',
    'erp-sync/config:getinvoicecutoffperiod',
    'erp-sync:getproblematicentities',
    'erp-sync:gettenantstatusmatrix',
    'erp-sync:status',
    'external/buyers:findexternalbuyer',
    'external/invoices:findexternalinvoice',
    'external/payments:find',
    'files:getdownloadurl',
    'files:public',
    'financial-connections/bank-transactions:banktransactionsstatus',
    'financial-connections:gettransactionscount',
    'financial-connections:querybalances',
    'financial-connections:queryownership',
    'financial-connections:querytransactions',
    'funds:available',
    'funds:counters',
    'funds:indicators',
    'gocardless/financial-connection:getbanks',
    'hubspot:createvisitoridentificationtoken',
    'intents/buyer-guarantee:contact',
    'intents/buyer:fetchbuyer',
    'intents/checkout:getholidays',
    'intents/checkout:getpromotions',
    'intents/invoice:downloadfiles',
    'intents/invoice:getpromotions',
    'intents/missing-information:getbuyermissinginformation',
    'intents/missing-information:getsuppliermissinginformation',
    'intents/supplier-data-connection:shopify',
    'invoices/aging:aging',
    'invoices/aging:total',
    'invoices/lifecycle:count',
    'invoices/lifecycle:indicators',
    'invoices/lifecycle:total',
    'invoices/ocr:showocrresult',
    'invoices:getbyexternalid',
    'invoices:ocr',
    'leads:exists',
    'notifications/user-customizations:getme',
    'notifications/user-settings:getme',
    'organizations:getdisplayorganization',
    'organizations:getorganizationdefaulttenant',
    'organizations:querydisplayorganizations',
    'payouts:counters',
    'payouts:querypayoutspendinglinking',
    'payouts:total',
    'plaid/link:linkreconnecttokencreate',
    'plaid/link:linktokencreate',
    'refunds:getstatusdates',
    'reports:getreport',
    'reports:getreportbybuyer',
    'reports:getreports',
    'rutter/companies:getentitiescount',
    'rutter:getpublickey',
    'search/geo-ip:countrybyip',
    'search/places:place',
    'search/places:places',
    'search:search',
    'transactions:getrelatedtransactions',
    'transactions:gettransactionsoverview',
    'transactions:getwithdrawdisabled',
    'users/roles:getrolepermissions',
    'users/settings:getcontact',
    'users/settings:geterpsettings',
    'users/settings:getnotificationsettings',
    'users/settings:querycontacts',
    'users/settings:theme',
    'users:authpermissions',
    'users:credentials',
    'users:current',
    'users:guest',
    'users:resendemailverification',
    'wise/recipients:getwisedetails',
    'wiserfunding/companies:manualcompanysearch',
];
